import { Controller } from "stimulus"

export default class extends Controller {
    static targets = [ "loginModal" ];

    showModal(e) {
        if(e && e.stopPropagation) e.stopPropagation();

        let modalController = this.application.getControllerForElementAndIdentifier(
            this.loginModalTarget, "components--modal"
        );

        modalController.open();
    }
}
